import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Input from '@mui/joy/Input';

import Error from 'components/Error';
import Success from 'components/Success';

import CardLoggedOut from 'components/CardLoggedOut';
import LoadingSection from './LoadingSection';

import { TeamInviteType } from 'stores/team_invite_store';

import useTeamInvite from 'hooks/useTeamInvite';
import useUserIdentity from 'hooks/useUserIdentity';

import getIcon from 'utils/getIcon';


const TeamInviteAccept = observer(() => {

    const { fetchTeamInvite, acceptInvite } = useTeamInvite();
    const navigate = useNavigate();

    const [invite, setInvite] = useState<TeamInviteType|null>(null);
	const { uuid = "" } = useParams<{ uuid: string }>();
    const { currentIdentity } = useUserIdentity();
    const [fetched, setFetched] = useState(false);
    const [accepting, setAccepting] = useState(false);
    const [email, setEmail] = useState('');
    const [handle, setHandle] = useState('');
    const DayOnesChatIcon = getIcon('DayOnesChat')


    useEffect(() => {
        if(!fetched) {
            fetchTeamInvite(uuid)
                .then((m) => {
                    setInvite(m);
                    if (!email && m?.email) {
                        setEmail(m.email);
                        const [h] = m.email.split('@')
                        updateHandle(h);
                    }
                    console.log('fetchmyteam', m);
                })
                .finally(() => {
                    setFetched(true);
                });
        }
    }, []);

    function updateHandle(s: string) {
        const handle = s.replace(/[^a-zA-Z0-9]/g, '');
        setHandle(handle);
        return handle;
    }

    function joinTeam() {
        console.log('joinTeam', invite);
        if (!invite?.uuid) {
            Error("Unable to join this team, missing invite");
            return;
        }

        setAccepting(true);
        acceptInvite(invite.uuid, email, handle)
            .then(() => {
                if(currentIdentity.uuid) {
                    Success("Great! You're part of the team");
                    navigate("/");
                }
                else {
                    Success("Great! Let's get you signed in");
                    navigate(`/password/change?email=${encodeURIComponent(email)}`);

                }
            })
            .catch((e) => {
                if (e == 'accepted') {
                    Error("This invite has already been accepted");
                    return;
                }
                else if (e == 'on-team') {
                    Error("This person is already on a team");
                    return;

                }
            })
            .finally(() => {
                setAccepting(false);
            });

    }

    if (currentIdentity.team) {
        return (
            <Stack>You're already on a team: {currentIdentity.team}</Stack>
        );
    }

    if (invite?.accepted) {
        return (

                <Typography level="body-lg">This invite has already been accepted.</Typography>

        );
    }
    return (
            <Stack >
                {!fetched && <LoadingSection />}
                {fetched && !invite &&
                    <Stack>Can't find invite</Stack>
                }
                {(fetched && invite) &&
                    <Stack my={2} spacing={3}>

                    <Stack spacing={1}>

                            <Stack>
                                <Typography level="title-lg">What your email address?</Typography>
                                <Typography level="body-xs">Let's get you set up</Typography>
                            </Stack>
                            <Input value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                            />
                        </Stack>

                        <Stack spacing={1}>
                        <Stack>
                            <Typography level="title-lg">What's your @handle?</Typography>
                            <Typography level="body-xs">How show people refer to you in chat?</Typography>
                            </Stack>
                            <Input
                                value={handle}
                                startDecorator={<DayOnesChatIcon />}
                                onChange={(e) => updateHandle(e.target.value)}
                            />
                        </Stack>
                        <Button disabled={accepting} onClick={() => joinTeam()}>Join Team</Button>
                    </Stack>
                }
            </Stack>

    );
});

const TeamInviteAcceptContainer = observer(() => {
    const { currentIdentity } = useUserIdentity();
    if(currentIdentity?.uuid) {
        return <TeamInviteAccept />
    }
    else {
        return (
            <CardLoggedOut size="small">
            <TeamInviteAccept />
            </CardLoggedOut>
        );
    }



});

export default TeamInviteAcceptContainer;
